// Breadcrumbs
class Breadcrumbs {
    init () {
        let isFocus = false;

        $(document).on('click mouseenter', '.js-breadcrumbsWithChild', function (e) {
            e.stopPropagation();
            e.preventDefault();

            if (isFocus === false) {
                isFocus = true;
                $(this).attr('aria-expanded', 'true');
                $(this).closest('.cc-breadcrumbs__item').find('.cc-breadcrumbs__overlay').addClass('cc-open');
                $(this).closest('.cc-breadcrumbs__item').find('.cc-breadcrumbs__overlay').attr('aria-hidden', 'false');

                $(document).on('focusin', function (e) {
                    var $target = $(e.target);
                    if (!$target.closest('.cc-breadcrumbs__item.cc-hasChild').length) {
                        $(document).find('.cc-breadcrumbs__overlay.cc-open').closest('.cc-breadcrumbs__item').find('.js-breadcrumbsWithChild').attr('aria-expanded', 'false');
                        $(document).find('.cc-breadcrumbs__overlay.cc-open').attr('aria-hidden', 'true');
                        $(document).find('.cc-breadcrumbs__overlay.cc-open').removeClass('cc-open');
                    }
                });
            } else {
                isFocus = false;
                $(this).attr('aria-expanded', 'false');
                $(this).closest('.cc-breadcrumbs__item').find('.cc-breadcrumbs__overlay').removeClass('cc-open');
                $(this).closest('.cc-breadcrumbs__item').find('.cc-breadcrumbs__overlay').attr('aria-hidden', 'true');
            }
        });

        $(document).on('mouseleave', '.cc-breadcrumbs__item.cc-hasChild', function () {
            isFocus = false;

            $(this).find('.js-breadcrumbsWithChild').attr('aria-expanded', 'false');
            $(this).find('.cc-breadcrumbs__overlay').removeClass('cc-open');
            $(this).find('.cc-breadcrumbs__overlay').attr('aria-hidden', 'true');
        });
    }
}

const breadcrumbs = new Breadcrumbs();
export default breadcrumbs;
